// LICENSE_CODE ZON
 /*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties, useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_dashboard from '../../img/icons/24/dashboard.svg';
import {use_login} from './use_login';
import {Button} from '../../lib/button';
import styles from './nav_user.module.less';
// import {Lang_picker} from './lang_picker';

interface i_user_links_props {
    cp_after_login?: boolean;
    cp_link?: string;
}
const User_links = (props: i_user_links_props)=>{
    const {theme} = use_theme({def: 'hola2023'});
    const [shift, set_shift] = useState<number>(0);
    const {state} = useLocation();
    const start_ref = useRef<HTMLDivElement>();
    const {on_login, show_login_form} = use_login(
        props.cp_after_login, props.cp_link);
    useEffect(()=>{
        if (start_ref.current)
        {
            setTimeout(()=>{
                const w = start_ref.current.offsetWidth;
                set_shift(w);
            });
        }
    }, [start_ref.current]);
    useEffect(()=>{
        if ((state as object_of<boolean>)?.need_login)
            show_login_form();
    }, [state]);
    return <div className={cn(styles.user_links)}>
      {/* <Lang_picker/> */}
      <a style={{'--shift': `${shift}px`} as CSSProperties}
        className={cn(theme.u4, styles.login)} onClick={on_login}
        data-clickid="nav_login">Log in</a>
      <div ref={start_ref} className={styles.start}>
        <Button size="xs" caption="Get started" to="/pricing"
          clickid="nav_start"/>
      </div>
    </div>;
};

interface i_nav_user_props {
    has_user?: boolean;
    is_scrolled?: boolean;
    cp_after_login?: boolean;
    cp_link?: string;
}
export const Nav_user = (props: i_nav_user_props)=>{
    const {has_user, is_scrolled, cp_link, cp_after_login} = props;
    const cls = cn(styles.nav_user, styles.oculus_nav_user,
        is_scrolled && styles.scrolled);
    return <div className={cls}>
      {/* {has_user && <Lang_picker/>} */}
      {has_user ? <Button color="secondary" size="s"
        caption="Go to dashboard" to={cp_link} clickid="nav_dashboard"
        cls={styles.dashboard} icon_left={<Icon_dashboard/>}
      /> : <User_links cp_link={cp_link} cp_after_login={cp_after_login}/>}
    </div>;
};
